import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { getDepartureSubPath } from '@sola/my-sdk/constants.ts';
import { GraphQLCommitmentType, type GraphQLDepartureChild } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentAvatar } from '../../atoms/commitment-avatar/commitment-avatar.tsx';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
export type DepartureCtaSubProps = {
  child: GraphQLDepartureChild;
  departedChildGlobalId: string;
  autoAcceptDate?: string | null;
};
export const DepartureCtaSub: React.FC<DepartureCtaSubProps> = t0 => {
  const $ = _c(37);
  const {
    child,
    departedChildGlobalId,
    autoAcceptDate
  } = t0;
  const {
    t
  } = useTranslation("my");
  const t1 = child.displayName ?? "";
  let T0;
  let T1;
  let T2;
  let href;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== autoAcceptDate || $[1] !== child.globalId || $[2] !== child.imageUrl || $[3] !== departedChildGlobalId || $[4] !== t || $[5] !== t1) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const name = t1.trim();
      if (!name) {
        t7 = null;
        break bb0;
      }
      let t8;
      if ($[16] !== departedChildGlobalId) {
        t8 = getDepartureSubPath(departedChildGlobalId);
        $[16] = departedChildGlobalId;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      href = t8;
      T2 = PrimaryCta;
      t4 = "neutral";
      t5 = "sm";
      t6 = <PrimaryCtaIcon><CommitmentAvatar commitment={{
          commitmentType: GraphQLCommitmentType.ChildSponsorship,
          participant: {
            name,
            globalId: child.globalId,
            photoUrl: child.imageUrl
          }
        }} size="lg" responsive={true} /></PrimaryCtaIcon>;
      T1 = PrimaryCtaBody;
      t3 = <PrimaryCtaHeading>{t("my:sponsorshipRelationship.departures.cta.pendingSub.title", {
          name
        })}</PrimaryCtaHeading>;
      T0 = PrimaryCtaText;
      t2 = t("my:sponsorshipRelationship.departures.cta.pendingSub.subtitle", {
        name,
        autoAcceptDate,
        context: autoAcceptDate ? "withDate" : "withoutDate"
      });
    }
    $[0] = autoAcceptDate;
    $[1] = child.globalId;
    $[2] = child.imageUrl;
    $[3] = departedChildGlobalId;
    $[4] = t;
    $[5] = t1;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = href;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    href = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[18] !== T0 || $[19] !== t2) {
    t8 = <T0>{t2}</T0>;
    $[18] = T0;
    $[19] = t2;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== T1 || $[22] !== t3 || $[23] !== t8) {
    t9 = <T1>{t3}{t8}</T1>;
    $[21] = T1;
    $[22] = t3;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("my:sponsorshipRelationship.departures.cta.pendingSub.cta.title");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== href || $[28] !== t10) {
    t11 = <PrimaryCtaActions reverseOnDesktop={true}><div className="flex"><ButtonStyle variant="secondary" size="md"><Link href={href}>{t10}</Link></ButtonStyle></div></PrimaryCtaActions>;
    $[27] = href;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== T2 || $[31] !== t11 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t9) {
    t12 = <T2 variant={t4} size={t5}>{t6}{t9}{t11}</T2>;
    $[30] = T2;
    $[31] = t11;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};